import { useContext } from 'react';
import { Trans } from '@lingui/macro';
import ReadMore from '@components/read-more';

import { getTextColorClass, getColor, addClickableLinks } from '@utils/Utils';
import { useIsMobile } from '@utils/hooks/useIsMobile';
import { BasicData } from '@App';

import './style.scss';

const PricingComponent = () => {
    const { price, price_includes, price_excludes, theme } = useContext(BasicData);

    const colors = getColor(theme);
    const mobile = useIsMobile();

    return (
        <div className="trip-summary-pricing bg-white">
            <div className={`trip-summary-pricing-main ${getTextColorClass(colors?.secondary)}`}>
                <h2 className="text-md-center mb-[1.875rem]"><Trans>Pricing</Trans></h2>
                {price && <div className="break-words trip-summary-pricing-main-body" dangerouslySetInnerHTML={{ __html: addClickableLinks(price) }} />}
            </div>
            {price_includes && (
                <div className="trip-summary-price-inclusions">
                    {mobile
                        ? <>
                            <h4 className="read-more-header"><Trans>Includes</Trans></h4>
                                <ReadMore header="Includes" lines={10} maxHeightOverflow={210}>
                                    <div dangerouslySetInnerHTML={{ __html: addClickableLinks(price_includes) }} />
                                </ReadMore>
                        </>
                        : <>
                            <h4><Trans>Includes</Trans></h4>
                            <div className="break-words" dangerouslySetInnerHTML={{ __html: addClickableLinks(price_includes) }} />
                        </>
                    }
                </div>
            )}
            {price_excludes && (
                <div className="trip-summary-price-exclusions">
                    {mobile
                        ? <>
                            <h4 className="read-more-header"><Trans>Excludes</Trans></h4>
                            <ReadMore header="Excludes" lines={10} maxHeightOverflow={210}>
                                <div dangerouslySetInnerHTML={{ __html: addClickableLinks(price_excludes) }} />
                            </ReadMore>
                        </>
                        : <>
                            <h4><Trans>Excludes</Trans></h4>
                            <div className="break-words" dangerouslySetInnerHTML={{ __html: addClickableLinks(price_excludes) }} />
                        </>
                    }
                </div>
            )}
        </div>
    )
}

export default PricingComponent;